import { Component } from "@angular/core";
import { UnsubscriberComponent } from "src/app/components/shared/unsubscriber.component";
import { ActionCommand } from "src/app/interfaces/action-command";
import { ActionCommandService, ProgressInfo } from "src/app/services/action-command.service";
import { BehaviorSubject, Observable } from "rxjs";


@Component({
    selector: 'comand-progress',
    template: '',
    standalone: false
})
export class ComandProgressDialogBaseComponent extends UnsubscriberComponent {
    private refreshToken;
    private messageId: string;
    private isRefreshCanceled: boolean = false;
    private progressSubject: BehaviorSubject<ProgressInfo> = new BehaviorSubject<ProgressInfo>(null);

    public isRefreshRunning: boolean = false;
    public isExecutingCommand: boolean = false;
    public isComplete: boolean = false;
    public commandProgress$: Observable<ProgressInfo> = this.progressSubject.asObservable();

    constructor(
        protected commandService: ActionCommandService
    ) {
        super();
    }

    protected async sendCommand(command: ActionCommand) {
        this.isExecutingCommand = true;
        let cmdRes = await this.commandService.sendCommand(command);
     console.log(cmdRes);
        if (!cmdRes.isSuccess) {
            this.isExecutingCommand = false;
            return;
        }
        console.log("s");
        this.progressSubject.next({ progressInfo: { messageType: command.messageType, isCompleted: false, isFailure: false }} as ProgressInfo); // Will switch dialog view as soon as we start processing the command.
    
        this.messageId = cmdRes.messageId;        
        this.refreshProgress();
    }

    protected cancelRefresh() {
        this.isRefreshCanceled = true;
        clearTimeout(this.refreshToken);
        this.commandService.continueCommandInBackground(this.messageId);
        this.progressSubject.next(null);
    }

    protected async refreshProgress() {
        this.isRefreshRunning = true;
        let progress = await this.commandService.getCommandProgress(this.messageId);
        
        this.progressSubject.next(progress);

        if (!this.isRefreshCanceled && !progress.progressInfo?.isCompleted && !progress.progressInfo.exception && !progress.progressInfo.isFailure) {
            this.refreshToken = setTimeout(() => {
                this.refreshProgress()
            }, 20000);
        }

        if (!!progress.progressInfo?.isCompleted || !!progress.progressInfo.exception || progress.progressInfo.isFailure) {
            this.isComplete = true;
            this.commandService.addToCommandHistory(progress);
        }
        this.isRefreshRunning = false;
    }
}
